<template>
  <div class="gst-pop-outer">
    <div class="gst-popup-header">
      <div class="cart-title-text">Order Confirmation</div>
      <v-icon
        class="mdi-close-right"
        @click="onClose({ ...data, status: false })"
        >mdi-close</v-icon
      >
    </div>
    <div class="gst-popup" >
      <div class="price-row-pop" v-for="prod in data.prodObj" :key="prod.id">
        <div class="detail-2-line">
          <div class="left-text-style">{{ prod.group_name === 'SUBSCRIPTION' ? `Boost Up : ${prod.name}` : prod.group_name}}</div>
          <div v-if="prod.name" class="left-text-style">
            {{ prod.group_name === 'SUBSCRIPTION' ?  `(Valid upto- ${getFormatedDate(prod.valid_upto)} )` : prod.name }}
          </div>
        </div>
        <div class="left-text-style cp3-left-align">
          <span class="price-title">&#8377; </span>{{ prod.price }}
        </div>
      </div>

      <div class="price-row-pop">
        <div class="detail-2-line">
          <div class="left-text-style-gray">Total:</div>
        </div>
        <div class="left-text-style cp3-left-align">
          <span class="price-title">&#8377; </span
          >{{ data.priceDetails.total_product_amount }}
        </div>
      </div>
      <div class="price-row-pop">
        <div class="detail-2-line">
          <div class="left-text-style-gray">GST:</div>
        </div>
        <div class="left-text-style cp3-left-align">
          <span class="price-title">&#8377; </span
          >{{ (data.priceDetails.gst_amount).toFixed(2) }}
        </div>
      </div>
      <div class="price-row-pop">
        <div class="detail-2-line">
          <div class="left-text-style-gray">Grand Total:</div>
        </div>
        <div class="left-text-style cp3-left-align">
          <span class="price-title">&#8377; </span
          >{{ (data.priceDetails.total_amount_with_gst).toFixed(2)}}
        </div>
      </div>
      <div class="price-row-pop" v-if="discountAmount">
        <div class="detail-2-line">
          <div class="left-text-style-gray">Discount:</div>
        </div>
        <div class="left-text-style cp3-left-align">
          <span class="price-title">&#8377; </span>{{ discountAmount.toFixed(2) }}
        </div>
      </div>

      <div class="price-row-pop after-dis" v-if="discountAmount">
        <div class="detail-2-line">
          <div class="left-text-style">After Discount:</div>
        </div>
        <div class="left-text-style cp3-left-align">
          <span class="price-title">&#8377; </span
          >{{ totalAfterDiscount.toFixed(2) }}
        </div>
      </div>
      <div class="price-row-pop-input">
        <v-text-field
          v-model="couponCode"
          label="Have a discount code?"
          :counter="10"
          @keydown.space.prevent
          dense
          outlined
          hide-details
        >
          <template v-slot:append>
            <span
              v-if="couponCode.length && !isCouponCodeValid"
              class="code-span-btn"
              color="primary"
              text
              @click="verifyCouponCode()"
              >Apply</span
            >
            <span
              v-if="couponCode.length && isCouponCodeValid"
              class="code-span-btn"
              color="primary"
              text
              @click="clearCode(true)"
              >Remove</span
            >
          </template>
        </v-text-field>
        <InputError :data="error.couponCode" />
      </div>
      <div class="price-row-pop-input">
        <v-text-field
          v-model="gstNumber"
          label="Have a GST Number?"
          dense 
          outlined 
          hide-details
        >
          <template v-slot:append>
            <span
              v-if="gstNumber.length && isGstNumberValid"
              class="code-span-btn"
              color="primary"
              text
              @click="applyGstNumber()"
              >Apply</span
            >
            <span
              v-if="gstNumber.length && !isGstNumberValid"
              class="code-span-btn"
              color="primary"
              text
              @click="clearCode()"
              >Remove</span
            >
          </template>
        </v-text-field>
        <InputError :data="error.gstNumber" />
      </div>
      <div class="check-aggrement">
        <div class="check-cust">
          <v-checkbox v-model="isAgreed"></v-checkbox>
        </div>
        <div class="agree-text">I agree with the</div>
        <div
          class="terms-text"
          @click="
            onClose({ status: true, showTermsAndConditions: true, ...data })
          "
        >
          Terms and Conditions.
        </div>
      </div>
      <div class="cart-btn new-cr-cart">
        <v-btn
          :disabled="!isAgreed"
          color="primary"
          @click="
            onClose({
              status: false,
              payNow: true,
              ...data,
              couponCode: isCouponCodeApplied ? couponCode : '',
              gstNumber: isGstNumberApplied ? gstNumber : '',
            })
          "
          class="right-btn cust-btn pay-now-btn"
          >Pay Now &#8377;{{
            (isCouponCodeApplied ? totalAfterDiscount.toFixed(2) : (data.priceDetails.total_amount_with_gst).toFixed(2))
          }}</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import InputError from "../../InputError.vue";
import moment from "moment";
export default {
  name: "GstChargesPopUp",
  props: ["data", "onClose", "status"],
  data: function() {
    return {
      typetimeout: null,
      couponCode: "",
      gstNumber: "",
      discountAmount: "",
      discountPercentage: "",
      totalAfterDiscount: "",
      error: {
        couponCode: {
          type: null,
          message: "",
        },
        gstNumber: {
          type: null,
          message: "Sorry! This not a valid GST number.",
        },
      },
      isAgreed: false,
      isCouponCodeValid: false,
      isCouponCodeApplied: false,
      isGstNumberValid: false,
      isGstNumberApplied: false,
    };
  },
  methods: {
    ...mapActions({
      verifyCoupon: "userStore/verifyCoupon",
      applyCoupon: "userStore/applyCoupon",
    }),
    verifyCouponCode() {
      let product_ids = [];
      this.data.prodObj.forEach((pkg) => {
        product_ids.push(pkg.id);
      });
      let reqData = {
        coupon: this.couponCode,
        product_ids: product_ids,
      };
      this.verifyCoupon(reqData)
        .then((response) => {
          this.$root.showLoader = false;
          this.error.couponCode.type = 'null';
          this.applyCoupon(reqData)
            .then((response) => {
              if (response) {
                let maxAmtMsg = response.discount > response.coupon.coupon_amount ? `(Max. Amt. ₹${response.discount})` : ''
                this.$root.showLoader = false;
                this.error.couponCode.type = 'success';
                this.error.couponCode.message = `Congrats! You got a ${response.coupon.discount_percentage}% discount.`+ maxAmtMsg;
                this.discountAmount = response.discount;
                this.discountPercentage = response.coupon.discount_percentage;
                this.totalAfterDiscount = response.total_amount_after_discount;
                this.isCouponCodeApplied = true;
              }
            })
            .catch((e) => {
              console.log(e);
            }); 
          this.isCouponCodeValid = true;          
        })
        .catch((err) => {
          let errData = err && err.data && err.data.errors;
          if (errData && errData.length) {
            this.$root.showLoader = false;
            this.error.couponCode.type = "error";
            this.error.couponCode.message = errData[0].message;
            this.isCouponCodeApplied = false;
            this.isCouponCodeValid = true;
          }
        });
    },
    clearCode(isClearCode) {
      if (isClearCode) {
        this.couponCode = "";
        this.discountAmount = "";
        this.error.couponCode.type = null;
        this.isCouponCodeValid = false;
        this.isCouponCodeApplied = false;
      } else {
        this.gstNumber = "";
        this.error.gstNumber.type = null;
        this.isGstNumberValid = false;
        this.isGstNumberApplied = false;
      }
    },
    validate(isCode) {
      let isValid = true;
      isCode ? this.error.couponCode.type = null : this.error.gstNumber.type = null;
      this.error.gstNumber.type = null;
      if (this.couponCode && this.couponCode.length > 25) {
        this.error.couponCode.type = "error";
        isValid = false;
      }
      if (
        this.gstNumber &&
        this.gstNumber.length &&
        !this.isValidGST(this.gstNumber)
      ) {
        this.error.gstNumber.type = "error";
        isValid = false;
      }
      if(this.gstNumber && !isCode){
        this.isGstNumberValid = isValid;
      }
      return isValid;
    },
    getFormatedDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    isValidGST(num) {
      let regex = new RegExp(
        "^[0-9]{2}[A-Z]{5}[0-9]{4}" + "[A-Z]{1}[1-9A-Z]{1}" + "Z[0-9A-Z]{1}$"
      );
      if (regex.test(num)) {
        return true;
      }
      return false;
    },
    applyGstNumber(){
      this.isGstNumberValid = false;
      this.isGstNumberApplied = true;
    }
  },
  watch:{
    status(val){
      this.error.couponCode.type = null;
      this.error.gstNumber.type = null;
      if(!val){
        this.couponCode = '';
        this.gstNumber = '';
        this.discountAmount = "";
        this.error.couponCode.type = null;
        this.isCouponCodeValid = false;
        this.isCouponCodeApplied = false;
      }
    }
  },
  components: { InputError },
};
</script>
